export default function (state, getters, rootState, rootGetters) {
    if(!rootGetters.permission(34)) return false;

    return state.add_payment;
}